/*! hash:06b0d4e8a9e4ea1bc02d, chunkhash:8ad23ce5ea2ded474241, name:solution/index, filebase:index.8ad23ce5e.js, query:, file:static/js/solution/index.8ad23ce5e.js */
webpackJsonp([2],{

/***/ 17:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

__webpack_require__(1);

__webpack_require__(17);

__webpack_require__(2);

$(function () {
  $(window).resize(function () {
    Affix();
  });
  hoverCss();
  Affix();
  wayPoint();
  locationTab();
});

function hoverCss() {
  $('.solution-wrapper').find('.value-item').hover(function () {
    $(this).addClass('active');
  }, function () {
    $(this).removeClass('active');
  });
}
function wayPoint() {
  $('.page').waypoint(function (direction) {
    if (direction === 'down') {
      $(this.element).find('.state').addClass('animated slideInUp');
    }
  }, { offset: '70%' });
}
function Affix() {
  var affixTop = $(".solution-wrapper .offsetTop").offset().top;
  $('#affixBox').affix({
    offset: {
      top: affixTop
    }
  });
}
function locationTab() {
  if (window.location.hash) {
    // '#'需要转义
    $('#myTab a[href=\\' + window.location.hash + ']').tab('show');
  } else {
    $('#myTab a[href="#bus"]').tab('show');
  }
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ })

},[33]);


// WEBPACK FOOTER //
// static/js/solution/index.8ad23ce5e.js